import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Form, FormCheck } from "@govtechsg/sgds-react/Form";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
// import { Row } from '@govtechsg/sgds-react/Row'
import { Button } from "@govtechsg/sgds-react/Button";
import { Toast, ToastContainer } from "@govtechsg/sgds-react/Toast";

// Components
import HeaderRegComponent from "../Components/HeaderRegComponent";
import FooterComponent from "../Components/FooterComponent";

// Images
import img_onemap_attr from "../images/logo/round/omi_logo_attr@2x.png";

const ForgetPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [selectedOption, setSelectedOption] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();

  // const[showSuccess, setShowSuccess] = useState(false)

  const emailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleForget = (e) => {
    setSelectedOption(e.target.checked);
  };

  const [showToast, setShowToast] = useState(false);

  const [toastText, _setToastText] = useState("");

  const showToastMessage = (_text) => {
    _setToastText(_text);

    setShowToast(true);
  };

  const ToastComponent = () => {
    return (
      <ToastContainer>
        <Toast
          className="om-warning"
          show={showToast}
          onClose={() => setShowToast(false)}
        >
          <Toast.Header>
            <img src={img_onemap_attr} className="rounded me-2" alt="OneMap" />
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>
            <small>{toastText}</small>
          </Toast.Body>
        </Toast>
      </ToastContainer>
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const userEntered = e.target[0].value;

    const token = await executeRecaptcha("forgot");

    //axios.post('/api/public/user/forgetPasswordTest', {
    // console.log("CALLING", `${process.env.REACT_APP_FORGET_PASSWORD}`);
    axios
      .post(`${process.env.REACT_APP_FORGET_PASSWORD}`, {
        // axios.post('https://omi-gcc.smartgeo.sg/api/public/user/forgetPasswordTest', {
        email: userEntered,
        recaptchaBody: token,
      })
      .then((res) => {
        // console.log(
        //   "SUCCESFUL, TRYING TO CALL",
        //   "https://www.onemap.gov.sg/apidocs/resetpassword",
        // );
        // console.log("res", res);
        const { status } = res;
        if (status === 200) {
          // navigate(`${process.env.REACT_APP_PUBLIC_URL}/resetpassword`, { state: { email: email }})

          navigate("/resetpassword", { state: { email: userEntered } });

          // Use window.location for redirection
          // window.location.href =
          //   "https://www.onemap.gov.sg/apidocs/resetpassword?email=" +
          //   userEntered;
        }
      })
      .catch((err) => {
        // console.log(err);
        const {
          response: { status, data },
        } = err;
        if (status === 400 && data.message === "Recaptcha score is low") {
          showToastMessage(
            "Please refresh and try again or contact OneMap for support",
          );
        } else if (status === 400 && data.error) {
          showToastMessage(
            data.error.email
              ? data.error.email +
                  " Please contact OneMap if you have not verified your email."
              : "Please contact OneMap if you have not verified your email.",
          );
        } else //if (status === 400 || status === 404)
        {
          showToastMessage(data.error);
        }
      });
  };

  return (
    <>
      <Helmet>
        <title>Recover Your OneMap API Password | OneMap API</title>
        <meta
          name="description"
          content="Recover access to your OneMap API account by resetting your password. Enter your email and receive instructions to create a new password securely."
        />
      </Helmet>
      <div className="om-body container-fluid">
        <HeaderRegComponent />

        <div className="om-body-content pageBase">
          {toastText && <ToastComponent />}

          <div id="om-section-title" className="om-sections row">
            <h1>Forget Password</h1>
          </div>

          <Form onSubmit={handleSubmit} action="/home">
            <div id="om-section-forget-email" className="om-sections row">
              <div className="row mb-3">
                <Form.Group className="col-12" controlId="email">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Email"
                    required
                    onChange={emailChange}
                    defaultValue={email}
                  />
                </Form.Group>
              </div>

              <div className="row mb-3">
                <FormCheck
                  id="ackterms"
                  className="om-btn-agreement col-12"
                  type="checkbox"
                  name="ackterms"
                  label={
                    <div>
                      By confirming, I agree to the&nbsp;
                      <a
                        className="om-links"
                        href="https://www.onemap.gov.sg/legal/apitermsofservice.html"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        API Terms of service
                      </a>
                      of OneMap
                    </div>
                  }
                  onChange={handleForget}
                  value={selectedOption}
                  feedback="You must agree before submitting"
                  feedbackType="invalid"
                  required
                />
              </div>

              <div className="row">
                <div className="inline-block text-center">
                  <Button className="om-btn-form-submit om-red" type="submit">
                    Reset My Password
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>

        <FooterComponent />
      </div>
    </>
  );
};

export default ForgetPassword;
